/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './radiation-beam-parameter.reducer';

export const RadiationBeamParameterDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const radiationBeamParameterEntity = useAppSelector(state => state.radiationBeamParameter.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="radiationBeamParameterDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.radiationBeamParameter.detail.title">RadiationBeamParameter</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.radiationBeamParameter.id">Id</Translate>
            </span>
          </dt>
          <dd>{radiationBeamParameterEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.radiationBeamParameter.name">Name</Translate>
            </span>
          </dt>
          <dd>{radiationBeamParameterEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.radiationBeamParameter.description">Description</Translate>
            </span>
          </dt>
          <dd>{radiationBeamParameterEntity.description}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.radiationBeamParameter.value">Value</Translate>
            </span>
          </dt>
          <dd>{radiationBeamParameterEntity.value}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.radiationBeamParameter.active">Active</Translate>
            </span>
          </dt>
          <dd>{radiationBeamParameterEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.radiationBeamParameter.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{radiationBeamParameterEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.radiationBeamParameter.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{radiationBeamParameterEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.radiationBeamParameter.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{radiationBeamParameterEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.radiationBeamParameter.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{radiationBeamParameterEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.radiationBeamParameter.radiationType">Radiation Type</Translate>
          </dt>
          <dd>
            {radiationBeamParameterEntity.radiationTypes
              ? radiationBeamParameterEntity.radiationTypes.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {radiationBeamParameterEntity.radiationTypes && i === radiationBeamParameterEntity.radiationTypes.length - 1
                      ? ''
                      : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/radiation-beam-parameter" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/radiation-beam-parameter/${radiationBeamParameterEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RadiationBeamParameterDetail;
